import engineScript from "../../assets/engine.js?url"
 
export const PrebidLoader = {
  isLoaded: false,
  isLoading: false,

  async load(maxRetries = 5, scriptPath = engineScript) {
    if (this.isLoaded) {
      return true;
    }

    if (this.isLoading) {
      return new Promise(resolve => {
        const checkInterval = setInterval(() => {
          if (this.isLoaded) {
            clearInterval(checkInterval);
            resolve(true);
          }
        }, 100);
      });
    }

    this.isLoading = true;

    // 🔑 Ensure pbjs and $$PREBID_GLOBAL$$ point to the same object BEFORE import
    const shared = window.mypbjs || { que: [] };
    window.mypbjs = shared;
    
    let attempt = 0;
    let delay = 100;

    while (attempt < maxRetries) {
      try {

        await import(scriptPath);

        this.isLoaded = true;
        this.isLoading = false;
        //console.log("[PrebidLoader] Prebid.js successfully loaded.");
        return true;
      } catch (error) {
        //console.warn(`[PrebidLoader] Import failed (Attempt ${attempt + 1}/${maxRetries}). Retrying in ${delay}ms...`, error);
        attempt++;
        await new Promise(resolve => setTimeout(resolve, delay));
        delay *= 2;
      }
    }

    this.isLoading = false;
    //console.error("[PrebidLoader] Critical error: Failed to load Prebid.js. Bidding cannot proceed.");
    return false;
  }
};
